<template>
  <div class='bto-sb-range-slider' :class="{'bto-sb-range-full' : values.length === 1}">
    <div
      class='bto-sb-slider-values-container'
      :style='`order: ${!invertValuesPosition ? 2 : 1};`'
    >
      <div
        v-for='(value, idx) in values'
        :key='idx'
        class='bto-sb-slider-value'
        :class="{'bto-sb-slider-active' : currentStep === idx}"
        @click='explicitSelectValue(idx)'
        :style='`width: ${100 / values.length}%;`'
      >
        {{t(value)}}
      </div>
    </div>
    <div
      class='bto-sb-slider-container'
      :style='`order: ${!invertValuesPosition ? 1 : 2};`'
    >
      <input
        type='range'
        min='0'
        :max='stepSize * (values.length - 1)'
        value='0'
        :step='stepSize'
        @input='slide($event)'
        ref='rangeSlider'
      />
      <div
        class='bto-sb-slider-progress-bar'
        ref='rangeSliderProgressBar'
      ></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'RangeSliderComponent',
    data() {
      return {
        stepSize: 10,
        currentStep: 0,
      };
    },
    props: {
      values: {
        type: Array,
        required: true,
        default: () => [],
      },
      handlerFunction: {
        type: Function,
        required: true,
        default: () => {},
      },
      invertValuesPosition: {
        type: Boolean,
        required: false,
        default: false,
      },
      initialValue: {
        required: false,
      },
    },
    created() {
      this.$nextTick(() => {
        if (this.initialValue) {
          let idx = this.values.findIndex(v => v === this.initialValue);
          if (idx) {
            this.currentStep = (this.stepSize * idx) / this.stepSize;
            this.explicitSelectValue(idx);
          }
        }
      });
    },
    updated() {
      // this.$nextTick(() => {
        this.syntheticTriggerInputEvent();
      // });
    },
    methods: {
      syntheticTriggerInputEvent() {
        this.$refs.rangeSlider.dispatchEvent(new Event('input'));
      },
      slide(event) {
        let prevStep = this.currentStep;
        let thumbDiameter = 16;
        let percentage = ((event.target.value / event.target.max) * 100);
        this.currentStep = event.target.value / event.target.step;
        this.$refs.rangeSliderProgressBar
          .style
          .width = `calc(${percentage}% - ${(thumbDiameter / (this.values.length - 1)) * (this.currentStep)}px)`;

        if (this.currentStep !== prevStep) {
          this.handlerFunction(this.values[this.currentStep]);
        }
      },
      explicitSelectValue(idx) {
        this.$refs.rangeSlider.value = this.stepSize * idx;
        this.syntheticTriggerInputEvent();
      },
    },
  }
</script>
